<app-standard-page>
  <app-standard-page-content [limitWidth]="true">
    <app-standard-page-content-grid>
      @if (isLoaded) {
        @if (!isRedeemable) {
          <app-alert type="danger">
            <p>{{ isRedeemableMessage }}</p>
            <p>
              <a
                data-dd-action-name="offers.continue-setup-link"
                routerLink="/create-organisation"
                >Continue setting up my account</a
              >
            </p>
          </app-alert>
        }
      } @else {
        <app-loading
          message="Processing offer '{{ getOfferKey() }}'..."
        ></app-loading>
      }
    </app-standard-page-content-grid>
  </app-standard-page-content>
</app-standard-page>
